
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useTagSuggestions = () => {
  const [popularTags, setPopularTags] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchPopularTags = async () => {
      setIsLoading(true);
      setError(null);
      
      try {
        // Get all unique tags across all drawings
        const { data, error } = await supabase
          .from("whiteboard_history")
          .select("tags")
          .not("tags", "is", null);

        if (error) throw error;

        // Flatten the array of tag arrays and count occurrences
        const tagCounts: Record<string, number> = {};
        
        // Ensure data exists and is an array before processing
        if (data && Array.isArray(data)) {
          data.forEach(item => {
            if (item.tags && Array.isArray(item.tags)) {
              item.tags.forEach((tag: string) => {
                if (typeof tag === 'string') {
                  tagCounts[tag] = (tagCounts[tag] || 0) + 1;
                }
              });
            }
          });

          // Sort tags by popularity (occurrence count)
          const sortedTags = Object.entries(tagCounts)
            .sort((a, b) => b[1] - a[1])
            .map(item => item[0]);

          setPopularTags(sortedTags);
        } else {
          // If data is invalid, set to empty array
          setPopularTags([]);
        }
      } catch (error) {
        console.error("Error fetching popular tags:", error);
        setPopularTags([]);
        setError(error instanceof Error ? error : new Error("Unknown error"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchPopularTags();
  }, []);

  return { 
    popularTags: popularTags || [], // Always return an array
    isLoading,
    error
  };
};
